import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Plus } from "lucide-react";
import PromptVersionPicker from "../components/PromptVersionPicker";

export default function TemplatePromptSection({
  currentVersionId,
  currentVersionLabel,
  onAssignPrompt,
  isAssigningPrompt,
  onRequestNewPrompt,
  savesImmediately,
}: {
  currentVersionId?: string | null;
  currentVersionLabel?: string | null;
  onAssignPrompt: (promptVersionId: string | null, versionLabel?: string) => void;
  isAssigningPrompt: boolean;
  onRequestNewPrompt: () => void;
  savesImmediately: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Default Prompt</CardTitle>
        <CardDescription>Pick a prompt from the library, or write a new one without leaving this page</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-center justify-between gap-2">
          <label className="text-sm font-medium leading-none">Default Prompt</label>
          <Button type="button" size="sm" variant="outline" className="gap-1.5" onClick={onRequestNewPrompt}>
            <Plus className="h-4 w-4" /> New prompt
          </Button>
        </div>
        <PromptVersionPicker
          currentVersionId={currentVersionId}
          currentVersionLabel={currentVersionLabel}
          onAssign={onAssignPrompt}
          isSaving={isAssigningPrompt}
          allowReset={false}
          inheritLabel="No default prompt set. Pick one, or create a new one, so agents on this template have a prompt."
          assignedLabel="Agents on this template use this prompt version by default (unless individually overridden)."
        />
        <p className="text-sm text-muted-foreground">
          {savesImmediately
            ? "The prompt agents on this template inherit. Assigning a version saves right away."
            : "The prompt agents on this template inherit. It is saved together with the template."}
        </p>
      </CardContent>
    </Card>
  );
}
